import { marketPlaceFormRef, marketplaceType } from './consts';

export default function(editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  const pfx = options.pfx;
  if (options.blocks.indexOf(marketPlaceFormRef) >= 0) {
    bm.add(marketPlaceFormRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" fill="currentColor" class="bi bi-cart2" viewBox="0 0 16 16">
  <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>
</svg>
      <div>${options.labelMarketplaceForm}</div>`,
      category: options.labelMarketplaceFormCategory,
      content: `
        <form onsubmit="return purchaseItem(event)" class="${pfx} form-inline" data-gjs="marketplace-form" data-gjs-type="marketplace-form" action="#">
          <div class="form-group">
            <input name="collectionName" type="hidden"/>
            <input name="productId" type="hidden"/>
            <input name="quantity-field" type="hidden"/>
            <input name="price-field" type="hidden"/>
            <input name="name-field" type="hidden"/>
            <input name="description-field" type="hidden"/>
          </div>
          <div class="form-group">
            <input name="quantity" type="number" value="1" min="1" class="form-control"/>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary">Process Checkout</button>
          </div>
        </form>
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        options.labelMarketplaceForm
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
